import React, { useState, useEffect } from "react";
import jsonData from "./faucetList.json";

const FaucetTable = () => {
  const [data, setData] = useState([]);
  let myJdata = jsonData;
  // console.log("data is:", jsonData);
  useEffect(() => {
    setData(jsonData);
    console.log("First Time data is:", data);
  }, []);
  useEffect(() => {
    console.log("data is change:", data);
  }, [data]);

  const openLink = (id) => {
    let weblink = jsonData[id].Link;
    console.log("weblink:", id);
    window.open(weblink);
  };
  // filter for BTC coin Only
  const allFilter = () => {
    setData(jsonData);
  };
  const btcFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "BTC"));
  };
  const ltcFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "LTC"));
  };
  const ethFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "ETH"));
  };
  const dogeFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "DOGE"));
  };
  const tetherFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "USDT"));
  };
  const dashFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "DASH"));
  };
  const dgbFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "DGB"));
  };
  const trxFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "TRX"));
  };
  const bnbFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "BNB"));
  };
  const zecFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "ZEC"));
  };
  const feyFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "FEY"));
  };
  const solFilter = () => {
    setData(myJdata.filter((myJdata) => myJdata.CoinType === "SOL"));
  };
  return (
    <>
      {/* NavBar creating.................... */}
      

      <div className="container">
        <div className="text-center py-3 bg-">
        <div class="btn-group me-2 shadow-lg" role="group" aria-label="First group">
          <button type="button" class="btn btn-outline-primary" onClick={allFilter}>All</button>
          <button type="button" class="btn btn-outline-primary" onClick={btcFilter}>BitCoin</button>
          <button type="button" class="btn btn-outline-primary" onClick={ethFilter}>Ethereum</button>
          <button type="button" class="btn btn-outline-primary" onClick={ltcFilter}>Litecoin</button>
          {/* <button type="button" class="btn btn-outline-primary" onClick={}>BCH</button> */}
          <button type="button" class="btn btn-outline-primary" onClick={solFilter}>Solana</button>
          <button type="button" class="btn btn-outline-primary" onClick={tetherFilter}>USDT</button>
          <button type="button" class="btn btn-outline-primary" onClick={bnbFilter}>Binance</button>
          <button type="button" class="btn btn-outline-primary" onClick={trxFilter}>Tron</button>
          <button type="button" class="btn btn-outline-primary" onClick={feyFilter}>Feyora</button>
          <button type="button" class="btn btn-outline-primary" onClick={zecFilter}>Zcash</button>
          <button type="button" class="btn btn-outline-primary" onClick={dgbFilter}>DigiByte</button>
          <button type="button" class="btn btn-outline-primary" onClick={dashFilter}>Dashcoin</button>
        </div>
        </div>
      </div>

      {/* content is here */}
      <div className="py-4 text-center">
        <p>
          <b>
            Here is faucet site List, to get free Crypto Currency in your
            FaucetPay Account, If you don't have no worry about it,
            <br />
            Just Register on{" "}
            <a href="https://faucetpay.io/?r=4541865" target="_blank">
              FaucetPay
            </a>{" "}
            Account and enjoy your earning.
            <br /> No KYC is required, Only email veryfication.
          </b>
        </p>
      </div>

      {/* Data Table is creating */}
      <div className="container">
        <div className="py-4">
          <table class="table table-bordered table-striped table-hover table-info">
            <thead>
              <tr>
                <th width="20px">S.N.</th>
                <th>Site Name</th>
                <th>Coin</th>
                <th>Status</th>
                <th className="text-end">Link</th>
              </tr>
            </thead>
            <tbody>
              {data.map((val, key) => {
                return (
                  <tr key={val.id}>
                    <td>{val.id}*</td>
                    <td>{val.Name}</td>
                    <td>{val.CoinType}</td>
                    <td>Active</td>
                    <td className="text-end">
                      <a
                        href={val.Link}
                        className="btn btn-primary ms-auto"
                        target="_blank"
                      >
                        Visit
                      </a>
                      {/* <button
                        className="navbar navbar-dark ms-auto"
                        onClick={() => openLink(val.id)}
                      >
                        Visit
                      </button> */}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default FaucetTable;
